import { forConversation } from '../channels';
import { objectSchemaOf, Joi, actionCreator } from '../helpers';
import type { IEvent } from './event';
import { eventSchema } from './event';

export const NEW_EVENT = 'EVENT/NEW_EVENT';

export const newEventActionSchema = objectSchemaOf<INewEventAction>({
  type: Joi.string().required().valid(NEW_EVENT),
  payload: eventSchema.required(),
});

export interface INewEventAction {
  type: typeof NEW_EVENT;
  payload: IEvent;
}

export const newEventAction = actionCreator({
  type: NEW_EVENT,
  schema: newEventActionSchema,
  channels: [forConversation],
});
